import React from 'react'

import { BasicModal } from '@/components/layout/modals/BasicModal'
import { Button } from '@/components/buttons/Button'

import { formatVersionDate } from '../drawerHelpers'

// Confirmation modal for "Revert to this edit". Confirming dispatches
// revertPrompt — handled by PromptTab, not here. This component is purely a
// confirm-step surface. `latest` is resolved by the parent from the versions list.
const RevertConfirmModal = ({ show, node, latest, targetVersion, onCancel, onConfirm, busy }) => {
  if (!node) {
    return null
  }
  const isStale = targetVersion?.isCurrentSignature === false

  const renderBody = () => {
    if (!targetVersion) {
      return <p>No version selected.</p>
    }
    if (isStale) {
      return (
        <p>
          This version is stale (the variable contract has changed since it was saved). Reverting to
          it would break the prompt at runtime.
        </p>
      )
    }
    return (
      <p>
        This creates a <strong>new edit</strong> of the prompt with the content from{' '}
        <strong>{formatVersionDate(targetVersion.createdAt)}</strong>. The current content (from{' '}
        {latest ? formatVersionDate(latest.createdAt) : 'the latest version'}) stays in history.
      </p>
    )
  }

  return (
    <BasicModal
      show={show}
      onClose={onCancel}
      title={
        targetVersion
          ? `Revert ${node.config?.name || node.id} to ${formatVersionDate(targetVersion.createdAt)}?`
          : 'Revert prompt'
      }
      size="small"
      footer={
        <>
          <Button onClick={onCancel} data-testid="revert-cancel">
            Cancel
          </Button>
          <Button
            brand
            onClick={onConfirm}
            disabled={!targetVersion || isStale || busy}
            data-testid="revert-confirm"
          >
            {busy ? 'Reverting…' : 'Revert'}
          </Button>
        </>
      }
    >
      {renderBody()}
    </BasicModal>
  )
}

export default RevertConfirmModal
